import { GISServiceTypes } from '../gisServicesTypes';
import { LayerLoader } from './LayerLoader';
import { loadWithProperties } from './defaultLayerLoader';

/**
 * Load a basemap layer -- it should be visible by default.
 */
export const basemapLayerLoader: LayerLoader = {
  shouldUseLoader(service) {
    return service.service_type === GISServiceTypes.basemap;
  },
  async load(service) {
    const properties = {
      id: service.gisLayerID,
      visible: true,
      outFields: ['*'],
    };

    return loadWithProperties(service, properties);
  },
};
